import { usePathname } from "next/navigation";
import { useEffect } from "react";

import { useWorker } from "../useWorker";

export const useTrackPathName = () => {
  const { worker, isWorkerReady } = useWorker();

  const pathname = usePathname();

  useEffect(() => {
    if (!isWorkerReady) return;

    worker!.setValues({ pathname });
  }, [pathname, worker, isWorkerReady]);
};
